import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import RealtorLanding from '../../components/RealtorLanding/RealtorLanding';
import checkRtlLanguage from '../../utils/checkRtlLanguage';
import { openMessageModal, hideMessageModal } from '../../redux/modules/messageModal';
import { openContactFormModal, hideContactFormModal } from '../../redux/modules/contactFormModal';
import withPageWrapper from '../../containers/PageContainer/PageContainer';

class RealtorLandingPage extends Component {
  render() {
    return (
      <RealtorLanding {...this.props} />
    );
  }
}

RealtorLandingPage.propTypes = {
  translate: PropTypes.func,
  rootTranslate: PropTypes.func,
  locale: PropTypes.string,
  isMobile: PropTypes.bool
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'RealtorLanding'),
  packagesTranslate: getLang(state.lang, 'RealtorPackages'),
  rootTranslate: getLang(state.lang, 'static'),
  locale: state.lang.locale,
  isRtl: checkRtlLanguage(state.lang.locale),
  isMobile: state.windowDimentions.isMobile
});

export default connect(mapStateToProps, {
  openMessageModal,
  hideMessageModal,
  openContactFormModal,
  hideContactFormModal
})(
  withPageWrapper(RealtorLandingPage)
);
